import Dashboard from "../components/Dashboard/Dashboard.vue";
import Home from "../components/Dashboard/Home/Home.vue";
import MilkTypes from "../components/Dashboard/ProductCategories/MilkType/MilkTypes";
import MilkTypeDetails from "../components/Dashboard/ProductCategories/MilkType/MilkTypeDetails";
import MilkType from "../components/Dashboard/ProductCategories/MilkType/MilkType";
import CoffeeSizes from "../components/Dashboard/ProductCategories/CoffeeSize/CoffeeSizes";
import CoffeeSizeDetails from "../components/Dashboard/ProductCategories/CoffeeSize/CoffeeSizeDetails";
import CoffeeSize from "../components/Dashboard/ProductCategories/CoffeeSize/CoffeeSize";
import campaignsRoutes from "./campaigns";
import companyRoutes from "./company";
import onboardingRoutes from "./onboarding";
import panelUserRoutes from "./panel-user";
import readerAppUserRoutes from "./readerapp-user";
import reportsRoutes from "./reports";
import venueRoutes from "./venue";
import timePeriodRoutes from "./timeperiod";
import endUserManagementRoutes from "./enduser-management";
import helpMenuContentRoutes from "./help-menu-content";
import subscriptionPlanRoutes from "./subscription-plan";
import applyRoutes from "./apply";
import bannerRoutes from "./banner";

const dashboardRoutes = [

    {
        path: "/dashboard",
        component: Dashboard,
        meta: {
            required: true,
        },
        children: [
            {
                path: "",
                component: Home,
                meta: {
                    required: true,
                    roles: [
                        "PanelUser",
                        "PanelVenueUser",
                        "PanelReportUser",
                    ],
                },
                name: "Home",
            },           
            // {
            //   path: 'productCategories/milkTypes',
            //   component: MilkTypes,
            //   meta:{
            //     required:true,
            //     roles:["PanelUser"]
            //   },
            //   name:"MilkTypes"
            // },
            // {
            //   path: 'productCategories/milkType',
            //   component: MilkType,
            //   meta:{
            //     required:true,
            //     roles:["PanelUser"]
            //   },
            //   name:"MilkType"
            // },
            // {
            //   path: 'productCategories/milkType/:id',
            //   component: MilkTypeDetails,
            //   meta:{
            //     required:true,
            //     roles:["PanelUser"]
            //   },
            //   name:"MilkTypeDetails"
            // },
            // {
            //   path: 'productCategories/coffeeSizes',
            //   component: CoffeeSizes,
            //   meta:{
            //     required:true,
            //     roles:["PanelUser"]
            //   },
            //   name:"CoffeeSizes"
            // },
            // {
            //   path: 'productCategories/coffeeSize',
            //   component: CoffeeSize,
            //   meta:{
            //     required:true,
            //     roles:["PanelUser"]
            //   },
            //   name:"CoffeeSize"
            // },
            // {
            //   path: 'productCategories/coffeeSize/:id',
            //   component:  CoffeeSizeDetails,
            //   meta:{
            //     required:true,
            //     roles:["PanelUser"]
            //   },
            //   name:"CoffeeSizeDetailss"
            // },
            ...campaignsRoutes,
            ...companyRoutes,
            ...onboardingRoutes,
            ...panelUserRoutes,
            ...readerAppUserRoutes,
            ...reportsRoutes,
            ...timePeriodRoutes,
            ...venueRoutes,
            ...endUserManagementRoutes,
            ...helpMenuContentRoutes,
            ...subscriptionPlanRoutes,
            ...applyRoutes,
            ...bannerRoutes,
            {
                path: "*",
                redirect: "/dashboard",
                meta: {
                    required: false,
                },
            },
        ],
    },
]

export default dashboardRoutes;